
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M10.9402 8.11996L7.48016 4.65996L8.40016 3.64996C8.78016 3.23996 9.32016 2.99996 9.88016 2.99996H14.1202C14.6802 2.99996 15.2202 3.23996 15.5902 3.64996L16.8302 4.99996H20.0002C21.1002 4.99996 22.0002 5.89996 22.0002 6.99996V19C22.0002 19.05 21.9902 19.1 21.9802 19.16L16.8802 14.06C16.9602 13.71 17.0002 13.36 17.0002 13C17.0002 10.24 14.7602 7.99996 12.0002 7.99996C11.6402 7.99996 11.2902 8.03996 10.9402 8.11996ZM19.7802 22.61L18.1702 21H4.00016C2.90016 21 2.00016 20.1 2.00016 19V6.99996C2.00016 6.40996 2.27016 5.87996 2.68016 5.50996L1.39016 4.21996C1.00016 3.82996 1.00016 3.19996 1.39016 2.80996C1.78016 2.41996 2.41016 2.41996 2.80016 2.80996L21.1802 21.19C21.5702 21.58 21.5702 22.21 21.1802 22.6C20.8002 23 20.1702 23 19.7802 22.61ZM14.4902 17.32L12.9902 15.82C12.6702 15.92 12.3502 16 12.0002 16C10.3402 16 9.00016 14.66 9.00016 13C9.00016 12.65 9.08016 12.33 9.19016 12.02L7.69016 10.52C7.25016 11.24 7.00016 12.09 7.00016 13C7.00016 15.76 9.24016 18 12.0002 18C12.9102 18 13.7602 17.75 14.4902 17.32Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-no-photography`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNoPhotography

    ```js
    <b-new-b-icon-no-photography />
    ```
</docs>


